export const N71 = {
    "columns": 6,
    "rows": 2,
    "visual": {
        "id": 1,
        "type": "advancedTable",
        "colorTheme": 'colorTheme1',
        "title": "District Manager",
        "binding": {
            "data": {
                "columns": [
                    {
                        "name": 'DM Code',
                        "columnName": 'DistrictManagerCode',
                        "width": '150px',
                        "align": "left",
                        "sortable": true
                    },
                    {
                        "name": 'District Manager Name',
                        "columnName": 'DistrictManagerName',
                        "width": '230px',
                        "align": "left",
                        "sortable": true
                    },
                    {
                        "name": 'District Name',
                        "columnName": 'DistrictName',
                        "width": '200px',
                        "align": "left",
                        "sortable": true
                    },
                    {
                        "name": 'Actual Sales',
                        "columnName": 'ActualSales',
                        "width": '140px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    }
                ],
                "title": "DistrictManagerName",
                "endpoint": "N71",
                "parameters": [
                    { "key": "FromMonth", "value": "2024" },
                    { "key": "FromYear", "value": "1" },
                    { "key": "ToMonth", "value": "2024" },
                    { "key": "ToYear", "value": "1" },
                    { "key": "RegionCode", "value": "" },
                    { "key": "ConfigTypeCode", "value": "" }
                ]
            },
            "context": {
                "point": {
                    "onClick": {
                        "selectedValueColumn": "DistrictManagerNameDistrictName",
                        "selectedTitle": "Products",
                        "visual": [
                            {
                                "columns": 12,
                                "rows": 2,
                                "visual": {
                                    "id": 1,
                                    "type": "advancedTable",
                                    "colorTheme": 'colorTheme1',
                                    "title": "Products",
                                    "binding": {
                                        "data": {
                                            "columns": [
                                                {
                                                    "name": 'Item Name',
                                                    "columnName": 'ItemName',
                                                    "width": '200px',
                                                    "align": "left",
                                                    "sortable": true,
                                                    "sum": false,
                                                },
                                                {
                                                    "name": 'Actual Sales',
                                                    "columnName": 'ActualSales',
                                                    "width": '140px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true,
                                                },
                                                {
                                                    "name": 'LY Sales',
                                                    "columnName": 'LYSales',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true,
                                                },
                                                {
                                                    "name": 'Growth %',
                                                    "columnName": 'Growth',
                                                    "width": '118px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": false,
                                                    "percent": true
                                                },
                                                {
                                                    "name": 'Target',
                                                    "columnName": 'TargetSales',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true,
                                                },
                                                {
                                                    "name": 'Performance %',
                                                    "columnName": 'Performance',
                                                    "width": '150px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": false,
                                                    "percent": true
                                                }
                                            ],
                                            "title": "ItemName",
                                            "endpoint": "N71.1",
                                            "parameters": [
                                                { "key": "FromMonth", "value": "2024" },
                                                { "key": "FromYear", "value": "1" },
                                                { "key": "ToMonth", "value": "2024" },
                                                { "key": "ToYear", "value": "1" },
                                                { "key": "RegionCode", "value": "" },
                                                { "key": "DistrictManagerNameDistrictName", "value": "" },
                                                { "key": "ConfigTypeCode", "value": "" }
                                            ]
                                        },
                                        "context": {
                                            "point": {
                                                "onClick": {

                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        ]
                    }
                }
            }
        }
    }
}